// extracted by css-extract-rspack-plugin
export default {"container":"pVOTS7aWEE04RoxC","label":"Q3b8hNUw_B0bgOdg","count":"G7kIsPKjI2kO8hVr"};